import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    sales: [],
    summary: {
      totalAmount: 0,
      totalProfit: 0,
      totalItems: 0,
      invoiceCount: 0,
    },
    
  },
  loading: false,
  error: null,
   
};

const salesInvoiceReportSlice = createSlice({
  name: "salesInvoiceReport",
  initialState,
  reducers: {
    salesInvoiceReportRequest(state, action) {
      state.loading = true;
      state.error = null;
       
    },
    salesInvoiceReportSuccess(state, action) {
      const { business, sales, summary, dateRange } = action.payload.data;

      state.loading = false;
      state.data = {
        business,
        sales,
        summary,
        dateRange,
      };
      state.error = null;
    },
    salesInvoiceReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch sales invoice report";
    },
    resetSalesInvoiceReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
      state.filters = initialState.filters;
    },
    updateSalesInvoiceReportFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearSalesInvoiceReportFilters(state) {
      state.filters = initialState.filters;
    },
  },
});

export const {
  salesInvoiceReportRequest,
  salesInvoiceReportSuccess,
  salesInvoiceReportFailure,
  resetSalesInvoiceReport,
  updateSalesInvoiceReportFilters,
  clearSalesInvoiceReportFilters,
} = salesInvoiceReportSlice.actions;

export default salesInvoiceReportSlice.reducer;